import { useState } from 'react';

export const useBooleanState = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const toggle = () => {
    setValue((v) => !v);
  };

  return [value, setValue, toggle];
};
